import { buildModuleApi } from "../../../../../_CORE/API/_ApiUtil/_buildModuleApi";

const EXCLUDE_BULK = [
    "ARCHIVE", "RESTORE", "ARCHIVED", "BULK_CREATE", "BULK_ARCHIVE",
    "BULK_RESTORE", "BULK_REMOVE_REQUEST", "BULK_REMOVE_CONFIRM",
];

const MANUALS = buildModuleApi({
    prefix: "MANUALS",
    uri: "manuals",
    withExtra: false,
    exclude: EXCLUDE_BULK,
    overrides: {
        LIST: { url: "/manuals" },
        CREATE: { url: "/manuals" },
        UPDATE: { url: "/manuals" },
        REMOVE: { url: "/manuals" },
        DETAIL: { url: "/manuals/:id" },
    },
    extraActions: {
        SECTION_CREATE: { suffix: "/:manualId/sections" },
        SECTION_UPDATE: { suffix: "/sections" },
        SECTION_REMOVE: { suffix: "/sections" },
        SECTION_ARCHIVE_LIST: { suffix: "/sections/archived/list" },
        SECTION_ARCHIVE: { suffix: "/sections/:id/archive" },
        SECTION_RESTORE: { suffix: "/sections/:id/restore" },
        ENTRY_CREATE: { suffix: "/:manualId/entries" },
        ENTRY_UPDATE: { suffix: "/entries" },
        ENTRY_REMOVE: { suffix: "/entries" },
        ENTRY_ARCHIVE_LIST: { suffix: "/entries/archived/list" },
        ENTRY_ARCHIVE: { suffix: "/entries/:id/archive" },
        ENTRY_RESTORE: { suffix: "/entries/:id/restore" },
        ENTRY_USAGE: { suffix: "/entries/:id/usage" },
        ENTRY_DUPLICATE: { suffix: "/entries/:id/duplicate" },
        PAGE_CREATE: { suffix: "/:manualId/pages" },
        PAGE_UPDATE: { suffix: "/pages" },
        PAGE_REMOVE: { suffix: "/pages" },
        PAGE_ARCHIVE_LIST: { suffix: "/pages/archived/list" },
        PAGE_ARCHIVE: { suffix: "/pages/:id/archive" },
        PAGE_RESTORE: { suffix: "/pages/:id/restore" },
        PAGE_DUPLICATE: { suffix: "/pages/:id/duplicate" },
        PAGE_IMPORT_LEGACY: { suffix: "/:manualId/pages/import-legacy" },
        ARCHIVE_LIST: { suffix: "/archived/list" },
        ARCHIVE_ONE: { suffix: "/:id/archive" },
        RESTORE_ONE: { suffix: "/:id/restore" },
    },
});

export const MANUALS_API = MANUALS.API;
export const MANUALS_CONSTANTS = MANUALS.CONSTANTS;
export const MANUALS_ENDPOINTS = MANUALS.ENDPOINTS;
